export function dataLayerPush(data) {
  window['dataLayer'] = window['dataLayer'] || [];
  window['dataLayer'].push(data);
}